define('presentation/welcome/validators/onboardingInformationValidator',[
        'businessServices/country/countryCode',
        'businessServices/country/countryRegions',
        'businessServices/creditCards/creditCardValidations',
        'common/converters/phoneNumberFormatter',
        'common/specifications/validEmailAddressSpecification',
        'common/specifications/validUrlAddressSpecification',
        'constants/countryEnumerations',
        'presentation/common/validation/commonValidator',
        'presentation/common/validation/validationRule',
        'presentation/common/validation/validPhoneNumberSpecification'
    ],
    function() {
        return function() {
            let self = this;

            let _facade = null;
            let _viewModel = null;
            let _commonValidator = null;

            const CountryCodeConstructor = require('businessServices/country/countryCode');
            const _countries = new CountryCodeConstructor();

            const CountryRegionsConstructor = require('businessServices/country/countryRegions');
            const _countryRegions = new CountryRegionsConstructor();

            const CreditCardValidationConstructor = require('businessServices/creditCards/creditCardValidations');
            const _creditCardValidations = new CreditCardValidationConstructor();

            const PhoneNumberFormatter = require('common/converters/phoneNumberFormatter');
            const _phoneNumberFormatter = new PhoneNumberFormatter();

            const ValidEmailAddressSpecificationConstructor = require('common/specifications/validEmailAddressSpecification');
            const _validEmailAddressSpecification = new ValidEmailAddressSpecificationConstructor();

            const ValidPhoneNumberSpecificationConstructor = require('presentation/common/validation/validPhoneNumberSpecification');
            const _validPhoneNumberSpecification = new ValidPhoneNumberSpecificationConstructor();

            const ValidUrlAddressSpecification = require('common/specifications/validUrlAddressSpecification');
            const _validUrlAddressSpecification = new ValidUrlAddressSpecification();

            const CommonValidatorConstructor = require('presentation/common/validation/commonValidator');
            const ValidationRulesConstructor = require('presentation/common/validation/validationRule');

            const _countryEnumerations = require('constants/countryEnumerations');

            self.registerViewModel = (viewModel, facade) => {

                _viewModel = viewModel;
                _facade = facade;
                _commonValidator = new CommonValidatorConstructor(_viewModel);

                const validationRules = new ValidationRulesConstructor();
                validationRules.field("addressLineOne")
                    .addValidationKeyUp(_validateAddressLineOne)
                    .addValidationI18n(_validateAddressLineOne, 'onboardingInformation:addressRequired');
                validationRules.field("city")
                    .addValidationKeyUp(_validateCity)
                    .addValidationI18n(_validateCity, 'onboardingInformation:cityRequired');
                validationRules.field("stateProvince")
                    .addValidationKeyUp(_validateStateProvince)
                    .addValidationI18n(_validateStateProvince, _stateOrProvinceRequiredI18nKey);
                validationRules.field("postalCode")
                    .addValidationKeyUp(_validatePostalCode)
                    .addValidationI18n(_validatePostalCodeRequired, _postalCodeRequiredI18nKey)
                    .addValidationI18n(_validatePostalCode, _postalCodeInvalidI18nKey);
                validationRules.field("phoneNumber")
                    .addValidationKeyUp(_validatePhoneNumberField)
                    .addValidationI18n(_validatePhoneNumberRequired, 'onboardingInformation:phoneNumberRequired')
                    .addValidationI18n(_validatePhoneNumberField, 'phoneNumberInvalid');
                validationRules.field("faxNumber")
                    .addValidationKeyUp(_validateFaxNumberField)
                    .addValidationI18n(_validateFaxNumberRequired, 'onboardingInformation:faxNumberRequired')
                    .addValidationI18n(_validateFaxNumberField, 'onboardingInformation:faxNumberInvalid');
                validationRules.field("emailAddress")
                    .addValidationKeyUp(_validateEmailAddress)
                    .addValidationI18n(_validateEmailAddressRequired, 'onboardingInformation:emailAddressRequired')
                    .addValidationI18n(_validateEmailAddress, 'emailAddressInvalid');
                validationRules.field("websiteUrl")
                    .addValidationKeyUp(_validateWebsiteUrl)
                    .addValidationI18n(_validateWebsiteUrlRequired, 'onboardingInformation:websiteUrlRequired')
                    .addValidationI18n(_validateWebsiteUrl, 'onboardingInformation:websiteUrlInvalid');
                validationRules.array("teamMembers")
                    .arrayField("name")
                    .addValidationI18n(_isTeamMemberProvided, 'onboardingInformation:teamMemberRequired');

                validationRules.validationGroupKeyUp('isValid', [
                    'addressLineOne',
                    'city',
                    'postalCode',
                    'phoneNumber',
                    'faxNumber',
                    'emailAddress',
                    'websiteUrl'
                ]);

                _commonValidator.setValidationRules(validationRules);
            };

            self.validate = () => {
                return _commonValidator.validate();
            };

            const _removeSpacesFromString = (string) => string.replace(/\s+/g, '');

            const _isBusinessLocationShared = () => _viewModel.shouldDisplayBusinessLocation() === true;

            const _validateAddressLineOne = (addressLineOne) => {
                return _isBusinessLocationShared() === false || _commonValidator.isStringWithValue(addressLineOne);
            };

            const _validateCity = (city) => {
                return _isBusinessLocationShared() === false || _commonValidator.isStringWithValue(city);
            };

            const _validatePostalCodeRequired = (postalCode) => {
                return _isBusinessLocationShared() === false || _commonValidator.isStringWithValue(postalCode);
            };

            const _validatePostalCode = (postalCode) => {
                return _isBusinessLocationShared() === false || _validatePostalCodeValid(postalCode);
            };

            const _validateStateProvince = (stateProvince) => {
                if (_isBusinessLocationShared() === false) {
                    return true;
                }
                if (stateProvince[0]) {
                    return _countryRegions.isValidStateOrProvince(stateProvince[0], _viewModel.country()[0]);
                }
                return false;
            };

            const _stateOrProvinceRequiredI18nKey = ko.pureComputed(() => {
                return _viewModel.country()[0] === _countryEnumerations.ca ?
                    'onboardingInformation:provinceRequired' :
                    'onboardingInformation:stateRequired';
            });

            const _validatePostalCodeValid = (postalCode) => {
                if (postalCode) {
                    return _creditCardValidations.validatePostalCodeFormat(_removeSpacesFromString(postalCode), _currentCountry());
                }

                return false;
            };

            const _currentCountry = ko.pureComputed(() => {
                if (_viewModel.country()[0]) {
                    return _countries.findByAbbreviation(_viewModel.country()[0]);
                }

                return _countries.getDefaultCountry();
            });

            const _postalCodeRequiredI18nKey = ko.pureComputed(() => _currentCountry().hasProvinces ?
                'onboardingInformation:postalCodeRequired' :
                'onboardingInformation:zipCodeRequired');

            const _postalCodeInvalidI18nKey = ko.pureComputed(() => _currentCountry().hasProvinces ?
                'onboardingInformation:postalCodeInvalid' :
                'onboardingInformation:zipCodeInvalid');

            const _validatePhoneNumberRequired = (phoneNumber) => {
                return _viewModel.shouldDisplayPhoneNumber() === false ||
                    _commonValidator.isStringWithValue(phoneNumber);
            };

            const _validateFaxNumberRequired = (faxNumber) => {
                return _viewModel.shouldDisplayFaxNumber() === false ||
                    _commonValidator.isStringWithValue(faxNumber);
            };

            const _validateEmailAddressRequired = (emailAddress) => {
                return _viewModel.shouldDisplayEmailAddress() === false ||
                    _commonValidator.isStringWithValue(emailAddress);
            };

            const _validateWebsiteUrlRequired = (websiteUrl) => {
                return _viewModel.shouldDisplayWebsiteUrl() === false ||
                    _commonValidator.isStringWithValue(websiteUrl);
            };

            const _isTeamMemberProvided = (name) => {
                if (_viewModel.shouldDisplayTeamMembers() !== true) {
                    return true;
                }
                if (_commonValidator.isStringWithValue(name)) {
                    return true;
                }
                return _viewModel.teamMembers()
                    .some((teamMember) => _commonValidator.isStringWithValue(teamMember.name()));
            };

            const _validatePhoneNumberField = (phoneNumber) => {
                return _viewModel.shouldDisplayPhoneNumber() === false || _validatePhoneNumber(phoneNumber);
            };

            const _validateFaxNumberField = (faxNumber) => {
                return _viewModel.shouldDisplayFaxNumber() === false || _validatePhoneNumber(faxNumber);
            };

            const _validatePhoneNumber = (phoneNumber) => {
                if (_commonValidator.isStringWithValue(phoneNumber)) {
                    let cleanPhoneNumber = _phoneNumberFormatter.clean(phoneNumber);
                    return _validPhoneNumberSpecification.isSatisfiedBy(cleanPhoneNumber, _countryEnumerations.usa);
                } else {
                    return true;
                }
            };

            const _validateEmailAddress = (emailAddress) => {
                if (_viewModel.shouldDisplayEmailAddress() === false) {
                    return true;
                }
                if (_commonValidator.isStringWithValue(emailAddress)) {
                    return _validEmailAddressSpecification.isSatisfiedBy(emailAddress.trim());
                } else {
                    return true;
                }
            };

            const _validateWebsiteUrl = (websiteUrl) => {
                if (_viewModel.shouldDisplayWebsiteUrl() === false) {
                    return true;
                }
                if (_commonValidator.isStringWithValue(websiteUrl)) {
                    return _validUrlAddressSpecification.isSatisfiedBy(websiteUrl);
                }
                return true;
            };
        };
    });
